import React from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

import '../css/signupwrangler.css';

function useQuery() {
   const { search } = useLocation();
   return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function Wrangler(props) {
   const [email, setEmail] = React.useState();
   const [firstName, setFirstName] = React.useState();
   const [gender, setGender] = React.useState('Gender');
   const [zipCode, setZipCode] = React.useState();
   // const [signUpWrangler, setSignUpWrangler] = React.useState(true);
   const [privacyPolicy, setPrivacyPolicy] = React.useState(false);
   const [privacyPolicyTouched, setPrivacyPolicyTouched] = React.useState(false);
   const [agreeToTnC, setAgreeToTnC] = React.useState(false);
   const [agreeToTnCTouched, setAgreeToTnCTouched] = React.useState(false);
   const [campaignId, setCampaignId] = React.useState();
   const [storeId, setStoreId] = React.useState();
   const [source, setSource] = React.useState();
   const [errorEmail, setErrorEmail] = React.useState();
   const [errorGender, setErrorGender] = React.useState();
   const [errorZipcode, setErrorZipcode] = React.useState();

   const handleEmailChange = (event) => {
      setEmail(event.target.value);
   };

   const handleFirstNameChange = (event) => {
      setFirstName(event.target.value);
   };

   const handleGenderChange = (event) => {
      setGender(event.target.value);
   };

   const handleZipCodeChange = (event) => {
      setZipCode(event.target.value);
   };

   // const handleSignUpWranglerChange = (checked) => {
   //    setSignUpWrangler(!checked);
   // };

   const handlePrivacyPolicyChange = (checked) => {
      setPrivacyPolicy(!checked);
      setPrivacyPolicyTouched(true);
   };

   const handleAgreeToTnCChange = (checked) => {
      setAgreeToTnC(!checked);
      setAgreeToTnCTouched(true);
   };

   let query = useQuery();
   const handleSignUp = () => {
      clearErrorMessage();
      if (validateForm()) {
         axios.post(`/wranglerLogin?node_mac=${query.get("node_mac")}&user_email=${email}&First_name=${firstName}&Gender=${gender}&zipcode=${zipCode}&campaignId=${campaignId}&storeId=${storeId}&source=${source}`, {})
            .then(res => {
               console.log(`Success: ${res}`);
               window.location.replace('http://n73.network-auth.com/splash/grant?continue_url=https://www.wrangler.com/');
            })
            .catch(err => {
               console.log(`Error: ${err}`);
            });
      }
   }

   const clearErrorMessage = () => {
      setErrorEmail("");
      setErrorGender("");
      setErrorZipcode("");
   }

   const validateForm = () => {
      if (email === undefined || email.trim().length === 0) {
         setErrorEmail("Please enter the Email!");
         return false;
      }
      if (!isEmailValid()) {
         setErrorEmail("Please enter a valid Email Address!");
         return false;
      }
      if (gender === undefined || gender.trim().length === 0 || gender === 'Gender') {
         setErrorGender("Please select the Gender!");
         return false;
      }
      if (zipCode !== undefined && zipCode.trim().length > 0 && !isZipCodeValid()) {
         setErrorZipcode("Please enter a valid Zip Code for this area store!");
         return false;
      }
      return true;
   }

   const isZipCodeValid = () => {
      return /^[0-9]{5}(?:-[0-9]{4})?$/.test(zipCode);
   }

   const isEmailValid = () => {

      if (email !== null && email !== undefined && email !== "") {
         if (email.indexOf("@") < 1 || email.lastIndexOf(".") < email.indexOf("@") + 2 || email.lastIndexOf(".") + 2 >= email.length)
            return false;
         else
            return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
      } else
         return false;

   }


   const handleNoThanks = () => {
      axios.post(`/wranglerSkipLogin?node_mac=${query.get("node_mac")}&user_email=${email}&First_name=${firstName}&Gender=${gender}&zipcode=${zipCode}&campaignId=${campaignId}&storeId=${storeId}&source=${source}`, {})
         .then(res => {
            console.log(`Success: ${res}`);
            window.location.replace('http://n73.network-auth.com/splash/grant?continue_url=https://www.wrangler.com/');
         })
         .catch(err => {
            console.log(`Error: ${err}`);
         });
   }

   return (
      <div className="Vans">
         <div id="emailSignup">
            <div className="header">
               <div className="logo">
                  <img src="/Wranglerlogo.gif" alt="Wrangler" />
               </div>
            </div>
            <div className="main">
               <h1 style={{
                  fontFamily: `"franklin-gothic-urw-cond", "Arial Narrow Bold", Arial, sans-serif`,
                  fontSize: '20px',
                  fontWeight: '700',
                  backgroundColor: '#cc071f',
                  color: '#fff',
                  lineHeight: '26px',
                  display: 'inline',
                  paddingLeft: '3px',
                  paddingRight: '3px',
               }}>Thanks for Visiting!</h1>
               <p>Sign up for Wrangler emails to get inside information and exclusive offers.</p>
               <div className="form">
                  <ul>
                     <li>
                        <input
                           maxLength="128"
                           value={email}
                           id="email"
                           name="user_email"
                           placeholder="Email Address*"
                           required
                           type="email"
                           style={{
                              backgroundImage: 'url(&amp;quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHklEQVQ4EaVTO26DQBD1ohQWaS2lg9JybZ+AK7hNwx2oIoVf4UPQ0Lj1FdKktevIpel8AKNUkDcWMxpgSaIEaTVv3sx7uztiTdu2s/98DywOw3Dued4Who/M2aIx5lZV1aEsy0+qiwHELyi+Ytl0PQ69SxAxkWIA4RMRTdNsKE59juMcuZd6xIAFeZ6fGCdJ8kY4y7KAuTRNGd7jyEBXsdOPE3a0QGPsniOnnYMO67LgSQN9T41F2QGrQRRFCwyzoIF2qyBuKKbcOgPXdVeY9rMWgNsjf9ccYesJhk3f5dYT1HX9gR0LLQR30TnjkUEcx2uIuS4RnI+aj6sJR0AM8AaumPaM/rRehyWhXqbFAA9kh3/8/NvHxAYGAsZ/il8IalkCLBfNVAAAAABJRU5ErkJggg==&amp;quot;)',
                              backgroundRepeat: 'no-repeat',
                              backgroundAttachment: 'scroll',
                              backgroundSize: '16px 18px',
                              backgroundPosition: '98% 50%',
                              cursor: 'auto'
                           }}
                           onChange={handleEmailChange}
                        />
                        <div style={{ color: 'red', fontSize: 'small' }}>
                           {errorEmail}
                        </div>
                     </li>
                     <li>
                        <input
                           maxLength="128"
                           value={firstName}
                           id="fname"
                           name="First_name"
                           placeholder="First Name"
                           type="text"
                           onChange={handleFirstNameChange}
                        />
                     </li>
                     <li>
                        <select
                           value={gender}
                           id="gender"
                           name="Gender"
                           placeholder="Gender"
                           onChange={handleGenderChange}
                        >
                           <option value="Gender" disabled>Gender</option>
                           <option value="M">M</option>
                           <option value="F">F</option>
                        </select>
                        <div style={{ color: 'red', fontSize: 'small' }}>
                           {errorGender}
                        </div>
                     </li>
                     <li>
                        <input
                           maxLength="128"
                           value={zipCode}
                           id="zip"
                           name="zipcode"
                           placeholder="Zip Code"
                           type="number"
                           onChange={handleZipCodeChange}
                        />
                        <div style={{ color: 'red', fontSize: 'small' }}>
                           {errorZipcode}
                        </div>
                     </li>
                  </ul>

                  <p className="requirements">*All fields required for sign up</p>
                  <br />
                  <div style={{
                     fontFamily: `"franklin-gothic-urw-cond", "Arial Narrow Bold", Arial, sans-serif`,
                     fontSize: '12px',
                     fontWeight: '700',
                     color: '#2b2b2b',
                     lineHeight: '12px',
                     margin: '0',
                     paddingTop: '4px',
                  }}>
                     {/* <input
                        type="checkbox"
                        name="signupSF"
                        id="signupSF"
                        checked={signUpWrangler}
                        onChange={() => handleSignUpWranglerChange(signUpWrangler)}
                     />
                     Sign up for Vans news, events and offers
                     <br /> */}
                     <input
                        type="checkbox"
                        name="privacypolicy"
                        id="privacypolicy"
                        checked={privacyPolicy}
                        onChange={() => handlePrivacyPolicyChange(privacyPolicy)}
                     />
                     I agree to Wrangler <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.wrangler.com/privacy.html"
                     >
                        Privacy Policy
                     </a>
                     {privacyPolicyTouched && !privacyPolicy && <div style={{ margin: 0, padding: 0, fontSize: '10px', color: 'red' }}>
                        You must accept the Privacy Policy.
                     </div>}
                     <br />
                     <input
                        type="checkbox"
                        name="signup"
                        id="signup"
                        checked={agreeToTnC}
                        onChange={() => handleAgreeToTnCChange(agreeToTnC)}
                     />
                     I agree to Wrangler <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.wrangler.com/terms.html"
                     >
                        Terms and Conditions
                     </a>
                     {agreeToTnCTouched && !agreeToTnC && <div style={{ margin: 0, padding: 0, fontSize: '10px', color: 'red' }}>
                        You must accept the Terms and Conditions.
                     </div>}
                     <br />
                  </div>

                  <div style={{ display: 'flex', padding: '0.3rem 0', marginTop: '.5rem' }}>
                     <div className="itemGroup">
                        <div className="itemCell" style={{ paddingRight: '20px' }}>
                           <button
                              type="submit"
                              id="submit"
                              name="submit"
                              onClick={handleSignUp}
                              disabled={!agreeToTnC}
                           >
                              SIGN UP
                           </button>
                        </div>
                     </div>
                     <div className="itemGroup">
                        <div className="itemCell">
                           <button
                              style={{ color: '00529F' }}
                              type="submit"
                              id="submit"
                              name="submit"
                              onClick={handleNoThanks}
                           >
                              No Thanks
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div >
            <div className="footer" style={{
               backgroundColor: '#000',
               padding: '27px 16px 27px 20px',
               marginTop: '24px',
            }}>
               {/* <div className="privacyPad">
                  <p>
                     <a
                        className="privacy"
                        href="https://www.wrangler.com/privacy.html"
                        target="_blank"
                        rel="noreferrer"
                     >
                        Privacy Policy
                     </a>
                  </p>
               </div> */}
               <p style={{
                  fontFamily: `"franklin-gothic-urw-cond","Arial Narrow Bold",Arial,sans-serif`,
                  fontSize: '10px',
                  fontWeight: '500',
                  lineHeight: '14px',
                  color: '#fff',
                  margin: '0',
               }}>&copy; Wrangler, A VF Company</p>
            </div>
         </div >
      </div >
   );
}